import { render, staticRenderFns } from "./Square-2.vue?vue&type=template&id=e288a5ac&scoped=true&"
import script from "./Square-2.vue?vue&type=script&lang=js&"
export * from "./Square-2.vue?vue&type=script&lang=js&"
import style0 from "./Square-2.vue?vue&type=style&index=0&id=e288a5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e288a5ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
